module.exports = __webpack_public_path__ + "img/Papua-New-Guinea.09082722.png";